/* Upload Fix v5 — Robust file upload for Shopify Dawn theme
 *
 * Problem: Dawn submits /cart/add via fetch(FormData), which works for text
 * inputs but Shopify's /cart/add.js endpoint does NOT process file uploads.
 * Files must be submitted via native <form> POST to /cart/add (non-.js).
 *
 * Strategy:
 *  1. Move file input inside the form (so form.submit() includes it)
 *  2. Override window.fetch — when Dawn tries to fetch /cart/add and a file
 *     is selected, cancel the fetch and force native form.submit() instead
 *  3. Show filename feedback on file selection
 */
(function(){
  var DEBUG = false;
  function log(msg){ if(DEBUG) console.log('[UploadFix]', msg); }

  function initUploadFix(){
    var form = document.querySelector('form[action*="/cart/add"]');
    if(!form){ log('No cart form found'); return; }

    var fileInput = document.querySelector('input[type="file"]');
    if(!fileInput){ log('No file input found'); return; }

    log('Found form and file input: ' + fileInput.name);

    /* --- Step 1: Move file input inside form --- */
    if(!form.contains(fileInput)){
      log('File input is outside form — moving it inside');
      /* Clone approach: create a new wrapper inside the form */
      var newWrap = document.createElement('div');
      newWrap.style.cssText = 'margin:12px 0;padding:0';

      /* Move the entire visual block (label + input + help text) */
      var sourceWrap = fileInput.closest('.lightly-spaced-row') ||
                       fileInput.closest('div[style]') ||
                       fileInput.parentElement;

      /* Insert into form before the submit button area */
      var submitArea = form.querySelector('.quantity-submit-row') ||
                       form.querySelector('.product-form__buttons') ||
                       form.querySelector('[type="submit"]');
      if(submitArea){
        var insertRef = submitArea;
        /* Walk up to direct child of form */
        while(insertRef && insertRef.parentElement !== form){
          insertRef = insertRef.parentElement;
        }
        if(insertRef && insertRef.parentElement === form){
          form.insertBefore(newWrap, insertRef);
        } else {
          form.appendChild(newWrap);
        }
      } else {
        form.appendChild(newWrap);
      }

      /* Move children from source into newWrap */
      if(sourceWrap){
        while(sourceWrap.firstChild){
          newWrap.appendChild(sourceWrap.firstChild);
        }
        /* Hide empty original */
        sourceWrap.style.display = 'none';
      }

      log('File input moved: form.contains = ' + form.contains(fileInput));
    } else {
      log('File input already inside form');
    }

    /* --- Step 2: Filename feedback --- */
    fileInput.addEventListener('change', function(){
      var st = fileInput.parentElement.querySelector('.gsup-status');
      if(!st){
        st = document.createElement('div');
        st.className = 'gsup-status';
        st.style.cssText = 'margin-top:6px;font-size:13px';
        fileInput.parentElement.appendChild(st);
      }
      if(this.files && this.files.length > 0){
        var f = this.files[0];
        var sizeMB = (f.size/1024/1024).toFixed(1);
        st.innerHTML = '<span style="color:#059669;font-weight:600">\u2705 ' +
          f.name + ' (' + sizeMB + ' MB)</span>';
        log('File selected: ' + f.name);
      } else {
        st.innerHTML = '';
      }
    });

    /* --- Step 3: Override fetch to force native submission with files --- */
    var origFetch = window.fetch;
    window.fetch = function(url, opts){
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
      if(urlStr.indexOf('/cart/add') !== -1 &&
         fileInput.files && fileInput.files.length > 0){
        log('Intercepting fetch /cart/add — forcing native form submit');

        /* Ensure form has correct attributes */
        form.setAttribute('enctype', 'multipart/form-data');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', '/cart/add');

        /* Verify file input is inside form */
        if(!form.contains(fileInput)){
          log('WARNING: file input still outside form, appending');
          form.appendChild(fileInput);
        }

        /* Native submit (bypasses JS handlers, includes files) */
        form.submit();

        /* Return a never-resolving promise so Dawn doesn't try to handle response */
        return new Promise(function(){});
      }
      return origFetch.apply(this, arguments);
    };

    /* --- Step 4: Also intercept button click as backup --- */
    var addBtn = form.querySelector('button[name="add"]') ||
                 form.querySelector('[type="submit"]');
    if(addBtn){
      addBtn.addEventListener('click', function(e){
        /* File is REQUIRED: no order without artwork [daniel, 2026-09-29] */
        if(!fileInput.files || fileInput.files.length === 0){
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          var er = document.getElementById('gsup-req-err');
          if(!er){ er = document.createElement('p'); er.id = 'gsup-req-err';
            er.style.cssText = 'color:#c00;font-weight:700;font-size:14px;margin:6px 0 0';
            er.textContent = '\u26a0\ufe0f Please upload your gang sheet file to continue';
            fileInput.parentElement.appendChild(er); }
          er.style.display = 'block';
          fileInput.scrollIntoView({behavior:'smooth', block:'center'});
          return;
        }
        var er0 = document.getElementById('gsup-req-err'); if(er0) er0.style.display = 'none';
        log('Click intercepted — file present, forcing native submit');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        form.setAttribute('enctype', 'multipart/form-data');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', '/cart/add');
        if(!form.contains(fileInput)){
          form.appendChild(fileInput);
        }
        form.submit();
      }, true);
    }

    log('Upload fix initialized');
  }

  /* Run with delays to handle Dawn's deferred rendering */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      setTimeout(initUploadFix, 500);
    });
  } else {
    setTimeout(initUploadFix, 500);
    setTimeout(initUploadFix, 2000);
  }
})();
